/**
 * Informace potřebné ke změně hesla.
 * @includeToDoc
 */
export interface IChangePasswordParams {
    /** Uživatelské jméno */
    userName: string;
    /** Staré heslo uživatele */
    oldPassword: string;
    /** Nové heslo uživatele */
    newPassword: string;
    /** Kód jazyka */
    language: string;
}

/**
 * Údaje nutné k přihlášení
 * @includeToDoc
 */
export interface ILoginCredentials {
    /** Uživatelské jméno */
    userName: string;
    /** Heslo uživatele */
    password: string;
    /** Kód jazyka */
    language: string;
}

/**
 * Parametry potřebné k provedení CheckLogon operace.
 * @includeToDoc
 */
export interface ICheckLoginParams {
    winAuth: boolean;
    sso: boolean;
}

export type AuthManagerChangePasswordType = {
    status: boolean;
    error?: {
        code: string;
        message: string;
    };
};

/**
 * Výsledek přihlášení
 *
 * @includeToDoc
 */
export type LoginResultData = {
    /** Výsledek přihlášení */
    result: string;
    /** AuthId, které je po přihlášení vráceno */
    authId: string;
};

/**
 * Výsledek kontroly přihlášení
 *
 * @includeToDoc
 */
export type CheckLoginResultData = {
    /** Informace zda je uživatel přihlášený */
    isLoggedIn: boolean;
    /** AuthId, které je platné pro aktuálního uživatele */
    authId: string | null;
};
